export default __webpack_public_path__ + "static/media/LightBlue0004.604e668b.png";